import { BUSINESS, CREATE_BUSINESS, FETCH_ALL_BUSINESSES, FETCH_BUSINESS, FETCH_BUSINESS_DATASET, SAVE_BUSINESS, SAVE_BUSINESS_STATUS } from "./ActionTypes";

const initialState: any = <any>{
    unsaved: {},
    dataset: [],
    saved: {},
    new: ''
};

export default function businessReducer(state = initialState, action: any) {
    const { payload }  = action;
    switch (action.type) {
        case SAVE_BUSINESS.SUCCESS: {
            const { data } = payload;

            return {
                ...state,
                saved: {...data}
            }
        }
        
        case CREATE_BUSINESS.SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                new: data?.id
            }
        }
        case FETCH_ALL_BUSINESSES.SUCCESS: {
            const { data } = payload;

            return {
                ...state,
                saved: {...data?.data},
                meta: data?.meta
            }
        }

        case FETCH_BUSINESS.SUCCESS:
        case SAVE_BUSINESS_STATUS.SUCCESS: {
            const { data } = payload;
            const key = Object.keys(data)[0];

            return {
                ...state,
                saved: {
                    ...state.saved,
                    [key]: data[key]
                },
                new: ''
            }
        }

        case FETCH_BUSINESS_DATASET.SUCCESS:{
            const { data } = payload;
            
            return {
                ...state,
                dataset: data
            }
        }

        case BUSINESS.EDIT: {
            const { candidateId, fieldId, valueId, value } = payload;

            return {
                ...state,
                unsaved: {
                    [candidateId]: {
                        ...state.unsaved[candidateId],
                        [fieldId]: {
                            id: valueId,
                            value: value    
                        },
                    }
                }
            }
        }

        case BUSINESS.RESET: {
            return {
                ...state,
                unsaved: {}
            }
        }





        case CREATE_BUSINESS.FAILURE:
            return {...state};

        default:
            return {...state};
    }
}